// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoHero_videoContainer__F3aVz","videoPlayer":"VideoHero_videoPlayer__pijxf","videoOverlay":"VideoHero_videoOverlay__SguT7","content":"VideoHero_content__AVzmB"};